import { Chart } from 'chart.js';
const template = require('./safe-draw-curve.tpl').default;

export default DomClass(template, function() {
	var xData = [];
	var yData = [];

	var data = this.data || [];
	for (var x = 0; x < data.length; x++) {
		xData.push(x);
		yData.push((data[x] * 100).toFixed(1));
	}
	var graphData = {
		labels: xData,
		datasets: [
			{
				backgroundColor: '#aea',
				borderColor: '#080',
				data: yData,
				label: 'P(All)',
				yAxisID: 'pAll',
				fill: true
			}
		]
	};

	var ctx = this.conditionalPAllGraph.getContext('2d');
	new Chart(ctx, {
		type: 'line',
		data: graphData,
		options: {
			legend: {
				display: false,
			},
			tooltips: {
				/* mode: 'index', */
				intersect: true
			},
			scales: {
				xAxes: [{
						scaleLabel: { display: true, labelString: 'Matching Cards in Hand' }
				}],
				yAxes: [{
					scaleLabel: { display: true, labelString: 'Success Rate (%)'},
					id: 'pAll',
					position: 'left'
				}]
			}
		}
	});

});
